import React from 'react';
import getConfig from '../../config';
import styles from './SummitLink.css';

const SummitLink = ({ loggedIn, pathname }) => (
    <React.Fragment>
        {loggedIn ? (
            <a
                title="Client Benefits"
                href="/personal-investing/about/client-benefits/index.html?src=summit-closed-fund"
            >
                Learn about Summit.
            </a>
        ) : (
            <a
                className="learnmore-summit"
                rel="noopener noreferrer"
                href={`${getConfig(
                    'envDomain'
                )}/usis/login/?pdurl=/v0/ciam-public/me%3fsdurl=${getConfig(
                    'envDomain'
                )}${pathname}`}
            >
                Log in to see if you qualify.
            </a>
        )}
        <style jsx>{styles}</style>
    </React.Fragment>
);

export default SummitLink;
